(function ($) {

  $(document).ready(function(){

    var clearS = function() {
      var $search = $('#product-search-form').find('input[name=s]');
      if ( ! $search.val().length ) {
        $search.attr('name', null);
      }
    };

    $('.rich-checkbox-input').click(function(){
      var $input = $('input[name=' + $(this).attr('data-src') + ']');
      var curVal = $input.val().split(' ') || [];
      var val = $(this).val();
      if ( $(this).attr('checked') ) {
        // Add value
        if ( curVal.indexOf(val) < 0 ) {
          curVal.push(val);
        }
      } else {
        // Remove value
        var index = curVal.indexOf(val);
        if ( index > -1 ) {
          curVal.splice( index, 1 );
        }
      }
      $input.val(curVal.join(' '));
      clearS();
      $('#product-search-form').submit();
    });

    $('#product-sort-order').change( function(){
      clearS();
      $('#product-search-form').submit();
    } );

    // 条件クリア
    $('a[data-remove]').click(function(){
      var id = $(this).attr('data-remove');
      $('#' + id).trigger('click');
    });

      $(function(){
          $(".accordionbox dt").on("click", function() {
              $(this).next().slideToggle();
              // activeが存在する場合
              if ($(this).children(".accordion_icon").hasClass('active')) {
                  // activeを削除
                  $(this).children(".accordion_icon").removeClass('active');
              }
              else {
                  // activeを追加
                  $(this).children(".accordion_icon").addClass('active');
              }
          });
      });
      
  });


})(jQuery);
